import React from 'react'
import Game from '../pages/Game';

const Menupage = () => {
  return (
    <>
    <Game/>
    </>
  )
}

export default Menupage
